<script>

export default {
    data(){
        return {
            msg: "잘못된 접근입니다.",
            tourl: "/signin", 
            icon: ""
        }
    },
    beforeMount(){
        this.redirect();
    },
    methods: {
        redirect: function(e){

            let uri = window.location.href.split('?');
            if(uri.length == 2) {
                let vars = uri[1].split('&');
                for (var i in vars) { 
                    var param = vars[i];
                    let s = param.split('=');
                    var k = s[0];
                    var v = s[1];
                    console.log(v);
                    if(k == 'code'){
                        switch(v) {
                            case "1":
                                this.msg = "잘못된 접근입니다.";
                                this.tourl = "/signin";
                                this.icon = "info"
                                break;
                            case "2":
                                this.msg = "마이파랑 서버에 연결할 수 없습니다.\n일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.";
                                this.tourl = "/signin";
                                this.icon = "info"
                                break;
                            case "11":
                                this.msg = '마이파랑 회원가입을 환영합니다. \n 로그인 페이지로 이동합니다.'
                                this.tourl = "/signin";
                                this.icon = "success"
                                break;
                            case "12":
                                this.msg = '이미 가입한 회원입니다. \n 로그인 페이지로 이동합니다.'
                                this.tourl = "/signin";
                                this.icon = "info"
                                break;
                            case "13":
                                this.msg = '[네이버 아이디로 가입] 한 회원입니다. \n 로그인 페이지로 이동합니다.'
                                this.tourl = "/signin";
                                this.icon = "info"
                                break;
                            case "14":
                                this.msg = '만료된 요청입니다.\n 다시 가입해주세요.'
                                this.tourl = "/signup";
                                this.icon = "info"
                                break;
                            case "19":
                                this.msg = "잘못된 접근입니다.";
                                this.tourl = "/signup";
                                this.icon = "info"
                                break;
                        }
                    }
                    
                }; 
                swal(this.msg, {icon: this.icon})
                .then(() => {
                    this.$router.push(this.tourl)
                });
            } else {
                swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", {icon: "info"})
            }
            
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Msg.vue